export const HOME_KIND_OF_COMPANY_TYPE = {
    OPERATOR: "nenda",
    CUSTOMER: "customer",
    ADVERTISER: "customer",
    RESELLER: "customer",
    SYSTEM_INTEGRATOR: "customer",
    CONTENT_OWNER: "content-owner",
};
export function homeKindOf(companyType) {
    if (!companyType)
        return "customer";
    return Object.prototype.hasOwnProperty.call(HOME_KIND_OF_COMPANY_TYPE, companyType)
        ? HOME_KIND_OF_COMPANY_TYPE[companyType]
        : "customer";
}
export function levelCap(kind) {
    return kind === "nenda" ? "administrate" : "edit";
}
